import {
  GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX, MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX,
} from '~/map/mapToolControls/mapOffsets.constants';
import { ZOOM_BUTTON_SIZE } from '~/map/mapToolControls/menuItems/zoomControls/zoomControls.component';

const SAFETY_GAP_PX = 8;

export const MOBILE_TOOL_PANEL_OPEN_BOTTOM_SAFE_OFFSET_PX = Math.max(
  GOOGLE_LOGO_SAFE_BOTTOM_OFFSET_PX,
  MAPS_ATTRIBUTION_BAR_BOTTOM_OFFSET_PX,
);

export const MOBILE_TOOL_PANEL_OPEN_LEFT_CLUSTER_BOTTOM_SHIFT_PX =
  MOBILE_TOOL_PANEL_OPEN_BOTTOM_SAFE_OFFSET_PX + 2 * ZOOM_BUTTON_SIZE + SAFETY_GAP_PX;
